import { Cookies } from 'react-cookie'
import { ErrorBox, YoutubeAuthCircle } from '../components/ErrorBox'
import { ThumbnailInfo } from '../components/thumbnail/Thumbnail'
import { CSSProperties, useEffect, useRef, useState } from 'react'
import { createLogger } from './logger'
import {
  NoUserModal,
  NoUserModalHome,
  SecretModal,
  SecretModalHome,
  SecretModalMyPage,
} from '../components/freePlan/WelcomeBox'
import { Me, UserSubscriptionInfo } from '../service/user'
import {
  PayBackBannerHome,
  PayBackBannerVideo,
} from '../components/payback/PayBackBanner'
import { subscriptionType } from '../service/plans'
import { ThumbnailOptionType } from 'dummy/data'
export const CASH_INFO_FIRST = [
  '캐시는 패스트컷 서비스 내에서만 사용하실 수 있으며, 서비스 외부에서 사용하실 수 없습니다.',
  '1캐시는 1원입니다.',
  '사용자는 캐시로 패스트컷 플랜 등 패스트컷 서비스 내에서 안내에 따라 상품 또는 서비스를 구매할 수 있습니다.',
  '캐시는 보너스 캐시가 먼저 사용되고 현금 캐시가 사용됩니다. 보너스 캐시는 유효기간이 임박한 순으로 먼저 사용됩니다.',
  '보너스 캐시는 유효기간이 캐시마다 상이하며, 보너스캐시의 유효기간이 별도로 명시되어 있지 않은 경우 유효기간은 1개월입니다.',
  '캐시는 제3자에게 양도가 불가능합니다.',
  '캐시는 만 14세 미만의 아동이 구매할 수 없습니다.',
]
interface CashType {
  first: { text: string; firstSubText?: string }
  second: { text: string; firstSubText?: string }
  third: { text: string; firstSubText?: string }
  fourth: { text: string; firstSubText?: string }
  fifth: { text: string; firstSubText?: string }
}
export const CASH_REFUND_INFO: CashType = {
  first: {
    text: '결제 후 캐시 사용이력(현금 캐시, 보너스 캐시 포함)이 전혀 없는 경우, 결제 후 7일 이내에 전액 환불이 가능하며, 현금 캐시만 환불이 가능합니다.',
  },
  second: {
    text: '7일이 지난 경우에는 미사용 캐시에 대하여 취소수수료(환불요청액의 10%)를 공제한 후 환불되나, 2천 캐시(2천원) 미만은 환불이 불가능합니다. 단, 취소수수료가 2천원보다 작은 경우에는 2천원을 취소수수료로 공제합니다',
    firstSubText:
      '캐시 구매에 따라 지급된 보너스 캐시가 있는 경우, 해당 보너스 캐시가 사용된 경우에는, 사용한 보너스 캐시도 환불액에서 공제됩니다.',
  },
  third: {
    text: '현금 캐시는 결제 후 1년간 미사용한 경우 기간 만료로 소멸됩니다.',
    firstSubText:
      '충전에 따라 지급된 보너스 캐시가 있는 경우, 해당 보너스 캐시에는 7일의 유효기간이 적용되며, 유효기간이 지난 보너스 캐시는 소멸됩니다.',
  },
  fourth: {
    text: '구매한 캐시가 아닌 보너스로 지급된 캐시는 현금으로 환불되지 않습니다.',
  },
  fifth: {
    text: '충전된 캐시의 이용기간과 환불가능기간은 결제시점으로부터 1년 이내로 제한됩니다.',
  },
}
export const CASH_INFO_SECOND = [
  '결제 후 캐시 사용이력(현금 캐시, 보너스 캐시 포함)이 전혀 없는 경우, 결제 후 7일 이내에 전액 환불이 가능하며, 현금 캐시만 환불이 가능합니다.',
  '7일이 지난 경우에는 미사용 캐시에 대하여 취소수수료(환불요청액의 10%)를 공제한 후 환불되나, 2천 캐시(2천원) 미만은 환불이 불가능합니다. 단, 취소수수료가 2천원보다 작은 경우에는 2천원을 취소수수료로 공제합니다.',
  '현금 캐시는 결제 후 1년간 미사용한 경우 기간 만료로 소멸됩니다.',
  '충전된 캐시의 이용기간과 환불가능기간은 결제시점으로부터 1년 이내로 제한됩니다.',
  '구매한 캐시가 아닌 보너스로 지급된 캐시는 현금으로 환불되지 않습니다.',
]
export enum UserType {
  USER = 'normalUser',
  라이트 = 'lightUser',
  프로 = 'proUser',
  프리미엄 = 'premiumUser',
  체험 = 'experienceUser',
  '숏폼 스페셜' = 'shortformSpecialUser',
}

export enum ChallengeStatusEnum {
  ACTIVATE = 'activate',
  CANCELLED = 'cancelled',
  COMPLETED = 'completed',
}

export const PREV_THUMBNAIL_INIT = { id: 0, index: 0 }
export const THUMBNAILINFO_LIST = 't_list'
export const LOCAL_THUMBNAIL_INFO = 'local_t'
export const THUMBNAIL_INFO: ThumbnailInfo = {
  channelName: '',
  title1: '',
  title2: '',
  title3: '',
}
const localStorageLogger = createLogger('localStorage')

export const saveLocalStorage = (key: string, value: any) => {
  try {
    localStorage.setItem(key, JSON.stringify(value))
  } catch (err) {
    localStorageLogger.error('Failed to save to localStorage', {
      key,
      error: err,
    })
  }
}

export const getLocalStorage = (key: string) => {
  try {
    const items = localStorage.getItem(key)
    if (items) {
      return JSON.parse(items)
    }
  } catch (err) {
    localStorageLogger.error('Failed to get from localStorage', {
      key,
      error: err,
    })
    return null
  }
}

export const getUtmLocalStorage = () => {
  try {
    const utm_source = localStorage.getItem('utm_source')
    const utm_campaign = localStorage.getItem('utm_campaign')
    if (utm_source && utm_campaign) {
      return {
        utmSource: JSON.parse(utm_source),
        utmCampaign: JSON.parse(utm_campaign),
        trackType: '',
      }
    }
  } catch (err) {
    localStorageLogger.error('Failed to get UTM from localStorage', {
      error: err,
    })
    return null
  }
}
export const removeLocalStorage = (key: string) => {
  try {
    localStorage.removeItem(key)
  } catch (err) {
    localStorageLogger.error('Failed to remove from localStorage', {
      key,
      error: err,
    })
  }
}

export const showErrorBox = (userInfo: any) => {
  if (!userInfo) {
    return
  }
  if (userInfo?.userInfo) {
    const { userType, userInfo: user } = userInfo
    const { youtubeAccount, youtubeChannel } = user

    if (
      (userType === UserType.프로 ||
        userType === UserType.프리미엄 ||
        userType === UserType.체험) &&
      !youtubeAccount
    ) {
      return (
        <>
          <ErrorBox />
        </>
      )
    } else if (
      (userType === UserType.프로 ||
        userType === UserType.프리미엄 ||
        userType === UserType.체험) &&
      youtubeAccount
    ) {
      if (
        !youtubeChannel[0]?.youtubeAuthorityFlag ||
        !youtubeChannel[0].advancedFlag
      ) {
        return (
          <>
            <ErrorBox />
          </>
        )
      }
    }
  }
}

export const showYoutubeAuth = (userInfo: any, className: string) => {
  if (!userInfo) {
    return
  }
  if (userInfo?.userInfo) {
    const { userType, userInfo: user } = userInfo
    const { youtubeAccount, youtubeChannel } = user

    if (
      (userType === UserType.프로 ||
        userType === UserType.프리미엄 ||
        userType === UserType.체험) &&
      !youtubeAccount
    ) {
      return (
        <>
          <YoutubeAuthCircle className={className} />
        </>
      )
    } else if (
      (userType === UserType.프로 ||
        userType === UserType.프리미엄 ||
        userType === UserType.체험) &&
      youtubeAccount
    ) {
      if (
        !youtubeChannel[0]?.youtubeAuthorityFlag ||
        !youtubeChannel[0].advancedFlag
      ) {
        return (
          <>
            <YoutubeAuthCircle className={className} />
          </>
        )
      }
    }
  }
}

const cookies = new Cookies()
export const setCookie = (
  name: string,
  value: string,
  exDay: number,
  options?: any
) => {
  const expires = new Date()
  expires.setDate(expires.getDate() + exDay) // 만료일 설정
  //expires.setSeconds(expires.getSeconds() + 30) // 30초 동안 유효
  cookies.set(name, value, { path: '/', expires, ...options })
}

export const getCookie = (name: string) => {
  return cookies.get(name)
}

export const MOBILE_NO_USER_BTN_LIST = [
  {
    name: '🎁 상품 영상 만들기',
    path: 'video-editor',
    event: false,
    showForLoggedIn: false,
    showForLoggedOut: true,
  },

  {
    name: '🎬 컨텐츠 영상 만들기',
    path: 'short-video-editor',
    event: false,
    showForLoggedIn: false,
    showForLoggedOut: true,
  },
  {
    name: '상품가격',
    path: 'price',
    event: false,
    showForLoggedIn: true,
    showForLoggedOut: true,
  },
  {
    name: '많이 묻는 질문 + 빠른 해결법',
    path: 'faq',
    event: false,
    showForLoggedIn: false,
    showForLoggedOut: true,
  },
]

export const MOBILE_SELECT_BTN_LIST_NO_USER = [
  {
    name: '🎁 상품 영상 만들기',
    path: 'video-editor',
    user: false,
  },
  {
    name: '🎬 컨텐츠 영상 만들기',
    path: 'short-video-editor',
    user: false,
  },

  { name: 'line', path: '', user: false },
  { name: '💰 상품 영상 플랜 가격', path: 'price-guide', user: false },
  { name: '💸 컨텐츠 영상 가격', path: 'shortform-price-guide', user: false },
  { name: 'line', path: '', user: false },

  { name: '블로그', path: 'blog', user: true },
  { name: '많이 묻는 질문+빠른 해결법', path: 'faq', user: false },
  { name: '로그인', path: 'sign-in', user: false, isLogin: false },
  { name: '회원가입', path: 'sign-up', user: false, isLogin: false },
]

export const MOBILE_SELECT_BTN_LIST = [
  {
    name: '🎁 상품 영상 만들기',
    path: 'video-editor',
    user: false,
  },
  {
    name: '🎬 컨텐츠 영상 만들기',
    path: 'short-video-editor',
    user: false,
  },
  { name: '사용 내역', path: 'my-videos', user: true },
  { name: '내 플랜', path: 'my-payments', user: true },
  { name: '캐시 관리', path: 'my-cash-dashboard', user: true },
  { name: 'line', path: '', user: false },
  { name: '💰 상품 영상 플랜 가격', path: 'price-guide', user: false },
  { name: '💸 컨텐츠 영상 가격', path: 'shortform-price-guide', user: false },
  { name: 'line', path: '', user: false },
  {
    name: '초대코드',
    path: 'my-page',
    user: true,
  },
  { name: '자동 업로드 설정', path: 'youtube-auth', user: true },
  { name: '블로그', path: 'blog', user: true },
  { name: '많이 묻는 질문+빠른 해결법', path: 'faq', user: false },
  { name: '로그아웃', path: 'logout', user: true, isLogin: true },
]

export const PC_SELECT_BTN_LIST = [
  {
    name: '상품 영상 만들기',
    path: 'video-editor',
  },
  {
    name: '컨텐츠 영상 만들기',
    path: 'short-video-editor',
  },
  { name: 'line', path: '' },
  { name: '사용 내역', path: 'my-videos' },
  { name: '내 플랜', path: 'my-payments' },
  { name: '캐시 관리', path: 'my-cash-dashboard' },
  { name: 'line', path: '' },
  { name: '초대코드', path: 'my-page' },
  { name: '자동 업로드 설정', path: 'youtube-auth' },
  { name: '블로그', path: 'blog' },
  { name: '많이 묻는 질문+빠른 해결법', path: 'faq' },
  { name: '로그아웃', path: 'logout' },
]
export const GNB = [
  {
    name: '상품 영상',
    path: 'video-editor',
    textMain: true,
    event: false,
  },
  {
    name: '컨텐츠 영상',
    path: 'short-video-editor',
    textMain: true,
    event: false,
  },
  { name: '가격 안내', path: 'price-guide', textMain: true, event: false },
  { name: '사용 내역', path: 'my-videos', textMain: true, event: false },
  // { name: '자주 묻는 질문', path: 'faq', textMain: true, event: false },
]

export const transitionSort: { key: 'id' | 'sort'; name: string }[] = [
  {
    key: 'sort',
    name: '추천순',
  },
  {
    key: 'id',
    name: '최신순',
  },
]

export const outroSort: { key: 'id' | 'sort'; name: string }[] = [
  {
    key: 'sort',
    name: '추천순',
  },
  {
    key: 'id',
    name: '최신순',
  },
]

export const extractNaverBlogURL = (url: string) => {
  const pattern = /https:\/\/m\.blog\.naver\.com\/[^\\/]+/
  const match = url.match(pattern)
  return match ? match[0] : null
}

export const extractTistoryBlogURL = (url: string) => {
  const pattern = /https:\/\/[^\\/]+\.tistory\.com/
  const match = url.match(pattern)
  return match ? match[0] : null
}

export const checkBlogExists = (url: string) => {
  const newUrl = transformBlogURL(url)
  return newUrl ?? url
}

export const checkClipExists = (url: string) => {
  const newUrl = transformClipURL(url)
  return newUrl ?? url
}
const transformClipURL = (url: string): string | null => {
  if (url.includes('blog.naver.com')) {
    return extractNaverBlogURL(
      url.replace('https://blog.naver.com', 'https://m.blog.naver.com')
    )
  }
  return null
}
const transformBlogURL = (url: string): string | null => {
  if (url.includes('blog.naver.com')) {
    return extractNaverBlogURL(
      url.replace('https://blog.naver.com', 'https://m.blog.naver.com')
    )
  }
  if (url.includes('tistory.com')) {
    return extractTistoryBlogURL(url)
  }
  return null
}

export const extractTikTokURL = (url: string) => {
  const pattern = /https:\/\/www\.tiktok\.com\/@[^\/?]+/ // 쿼리 파라미터를 포함하지 않도록 수정
  const match = url.match(pattern)
  return match ? match[0] : url
}

export function useCountdown(targetDate: Date, active: boolean) {
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  const calculateTimeLeft = () => {
    const difference = +targetDate - +new Date()
    return difference > 0 ? Math.floor(difference / 1000) : 0
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft)

  useEffect(() => {
    if (active) {
      intervalRef.current = setInterval(() => {
        setTimeLeft(calculateTimeLeft())
      }, 1000)
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [targetDate, active])

  const days = Math.floor(timeLeft / (24 * 60 * 60))
  const hours = Math.floor((timeLeft % (24 * 60 * 60)) / (60 * 60))
  const minutes = Math.floor((timeLeft % (60 * 60)) / 60)
  const seconds = timeLeft % 60

  const formattedTime = `${days}일 ${String(hours).padStart(2, '0')} : ${String(
    minutes
  ).padStart(2, '0')} : ${String(seconds).padStart(2, '0')}`

  return { days, hours, minutes, seconds, formattedTime }
}

export const renderUserModalsByMyVideo = (userInfo: Me) => {
  if (!userInfo) return <NoUserModal />

  const isTrialOrRegularUser =
    userInfo.userType === UserType.체험 || userInfo.userType === UserType.USER

  if (isTrialOrRegularUser && !userInfo.usage?.isDone) {
    return <SecretModal />
  }

  return null
}

export const renderUserModalsByHome = (userInfo: Me) => {
  if (!userInfo) return <NoUserModalHome />

  const isTrialOrRegularUser =
    userInfo.userType === UserType.체험 || userInfo.userType === UserType.USER

  if (isTrialOrRegularUser && !userInfo.usage?.isDone) {
    return <SecretModalHome />
  }

  return null
}
export const renderUserModalsMyPage = (userInfo: Me) => {
  if (!userInfo) return null

  const isTrialOrRegularUser =
    userInfo.userType === UserType.체험 || userInfo.userType === UserType.USER

  if (isTrialOrRegularUser && !userInfo.usage?.isDone) {
    return <SecretModalMyPage />
  }

  return null
}

export const renderUserModalsVideoEditor = (userInfo: Me) => {
  if (!userInfo) return <NoUserModalHome />

  const isTrialOrRegularUser =
    userInfo.userType === UserType.체험 || userInfo.userType === UserType.USER

  if (isTrialOrRegularUser && !userInfo.usage?.isDone) {
    return <SecretModalMyPage />
  }

  return null
}
export const renderPaybackHome = (userInfo: Me) => {
  return null
}

export const renderPaybackVideo = (userInfo: Me) => {
  return null
}

export const onLogOut = () => {
  removeLocalStorage('videoEditorData')
  removeLocalStorage('token')
  window.location.href = '/'
  setTimeout(() => {
    window.location.reload() // 그 후 새로 고침
  }, 1000) // 100ms의 딜레이를 주어 페이지 이동이 완료된 후 새로 고침
}

type Grade =
  | 'PREMIUM'
  | 'PRO'
  | 'LIGHT'
  | 'FREE'
  | '체험'
  | '프리미엄'
  | '프로'
  | '라이트'
  | '숏폼 스페셜'
  | 'SPECIAL'

export const gradePriority: Record<Grade, number> = {
  FREE: 3,
  체험: 3,
  LIGHT: 1,
  라이트: 1,
  PRO: 2,
  프로: 2,
  PREMIUM: 3,
  프리미엄: 3,
  '숏폼 스페셜': 4,
  SPECIAL: 4,
}

export const transitionPlanName: Record<string, Grade> = {
  프리미엄: 'PREMIUM',
  프로: 'PRO',
  라이트: 'LIGHT',
  체험: 'FREE',
  '숏폼 스페셜': 'SPECIAL',
}

export const handlPlanName = (
  userInfo: Me,
  userSubscriptionInfo: UserSubscriptionInfo | undefined
) => {
  let plan = ''
  switch (userInfo?.userType) {
    case UserType.USER:
      plan = '사용중인 플랜이 없어요'
      break
    case UserType.체험:
      plan = '무료 체험'
      break
    case UserType.라이트:
      plan = '라이트'
      break
    case UserType.프로:
      plan = '프로'
      break
    case UserType.프리미엄:
      plan = '프리미엄'
      break
    case UserType['숏폼 스페셜']:
      plan = '숏폼 스페셜'
      break
    default:
      plan = ''
  }

  if (userInfo?.subscriptions?.subscriptionType === subscriptionType.ANNUAL) {
    plan += ' 1년'
  } else if (
    userInfo?.subscriptions?.subscriptionType === subscriptionType.MONTHLY
  ) {
    if (userInfo?.billing?.connected && userInfo?.userType !== UserType.체험) {
      plan += ` ${userSubscriptionInfo?.lastSubscriptions?.subscriptionTypeLabel}`
    } else if (
      !userInfo?.billing?.connected &&
      userInfo?.userType !== UserType.체험
    ) {
      plan += ' 1개월'
    } else {
    }
  }

  return plan
}

/**
 *  @param {string} path - 로그인 혹은 회원가입후 돌아와야할 경로
 *  @param {function} prevSet - 전역상태 저장 함수
 */
export const savePrevPath = (path: string, prevSet: any) => {
  if (path) {
    prevSet({ prevUrl: path })
  }
}

export const getGridItemStyle = (selected: boolean): CSSProperties => ({
  width: '85px',
  height: '151px',
  position: 'relative',
  borderRadius: '4px',
  border: '1px solid #D9DEE8',
  overflow: 'hidden', // 이미지가 부모의 경계를 넘어가지 않도록 설정
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#FFFFFF',
  opacity: selected ? 1 : 0.3, // 선택되지 않은 경우 투명도 조절
})

// @ts-ignore
export const styles: { [key: string]: CSSProperties } = {
  input: {
    width: '100%',
    padding: '10px',
    marginBottom: '10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(8, 1fr)',
  },
  gridContainerMobile: {
    gridTemplateColumns: 'repeat(3, 1fr)', // 각 아이템의 너비를 유지하면서 자동으로 간격 조정
    justifyItems: 'center',
  },
  gridItemMobile: {
    width: '93px',
    height: '93px',
  },
  image: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    objectFit: 'contain', // 비율을 유지하며 부모를 꽉 채우도록 설정
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  checkbox: {
    marginRight: '8px',
    width: '16px',
    height: '16px',
  },
  label: {
    fontSize: '16px',
    color: '#333',
  },
}

export const initialThumbnailOption: ThumbnailOptionType = {
  name: 'thumbnail_01',
  titleList: [
    {
      title: {
        titleName: 'title1',
        titleContent: '',
        placeholder: '',
        maxLength: 0,
        color: '#FFFFFF',
      },
      position: '',
    },
    {
      title: {
        titleName: 'title2',
        titleContent: '',
        placeholder: '',
        maxLength: 0,
        color: '#FFFFFF',
      },
      position: '',
    },
    {
      title: {
        titleName: 'title3',
        titleContent: '',
        placeholder: '',
        maxLength: 0,
        color: '#FFFFFF',
      },
      position: '',
    },
  ],
}

export const CHANNEL_NAME_PATTERN = /^[^\uD800-\uDFFF&]*$/

export const THUMBNAIL_PATTERN = /^[^\uD800-\uDFFF]*$/

export const convertStorageUrlToCdn = (url: string): string => {
  try {
    if (!url || typeof url !== 'string') {
      return url || ''
    }
    
    if (url.includes('storage.googleapis.com/fast_cut/')) {
      return url.replace(
        'https://storage.googleapis.com/fast_cut/',
        'https://cdn.fastseller.shop/'
      )
    }
    
    return url
  } catch (error) {
    console.warn('URL 변환 중 오류 발생:', error)
    return url || ''
  }
}

export const convertMultipleStorageUrlsToCdn = (urls: string[]): string[] => {
  try {
    if (!Array.isArray(urls)) {
      return []
    }
    return urls.map(convertStorageUrlToCdn)
  } catch (error) {
    console.warn('다중 URL 변환 중 오류 발생:', error)
    return urls || []
  }
}
